// The last software keyboard's height, kept across page loads. A keyboard's
// height is a property of the device and its keyboard, not of the session, so
// the first keyboard of a load can be laid out for before it reports — the
// composer pill lifts toward where its edge will be (bottomEditorGlide) instead
// of waiting under it.
export const KEYBOARD_HEIGHT_STORAGE_KEY = 'treechat:keyboard-height'
const MAX_PLAUSIBLE_KEYBOARD_HEIGHT_PX = 1200

type StorageLike = Pick<Storage, 'getItem' | 'setItem'>

function safeStorage(): StorageLike | null {
    try {
        return typeof window === 'undefined' ? null : window.localStorage
    } catch {
        return null
    }
}

export function readRememberedKeyboardHeight(storage: StorageLike | null = safeStorage()): number {
    if (!storage) return 0
    try {
        const raw = storage.getItem(KEYBOARD_HEIGHT_STORAGE_KEY)
        const height = raw == null ? NaN : Number(raw)
        if (!Number.isFinite(height) || height <= 0 || height > MAX_PLAUSIBLE_KEYBOARD_HEIGHT_PX) {
            return 0
        }
        return Math.round(height)
    } catch {
        return 0
    }
}

export function rememberKeyboardHeight(
    height: number,
    storage: StorageLike | null = safeStorage(),
): void {
    if (!storage) return
    if (!Number.isFinite(height) || height <= 0 || height > MAX_PLAUSIBLE_KEYBOARD_HEIGHT_PX) return
    try {
        storage.setItem(KEYBOARD_HEIGHT_STORAGE_KEY, String(Math.round(height)))
    } catch {
        // Storage can be unavailable (private mode, sandboxed previews).
    }
}
